import React from 'react';

export default function App() {
  //Footer with github info.
  return (
      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        <a className='text-dark' href='https://github.com/olsson7/f1-map'>
        https://github.com/olsson7/f1-map
        </a>
      </div>
  );
}